import { getImageUrl } from "../../utils/images"

export const CustomCSS = () => {
    const css = `
    .login-right::before {
      background-image: url(${getImageUrl("login-right-bg.svg")}) !important;
    }
    .step1-bg::before {
        background-image: url(${getImageUrl("step1-bg.svg")}) !important;
      }

      .checkboxStyleTwo label::before {
        background-image: url(${getImageUrl("unchecked.svg")}) !important;
      }

      .checkboxStyleTwo input[type="checkbox"]:checked+label::before {
        background-image: url(${getImageUrl("checked.svg")}) !important;
      }
      .fileDrag::before {
        background-image: url(${getImageUrl("folder-open.svg")}) !important;
      }

      .fileDragDrop::before {
        background-image: url(${getImageUrl("upload-icon.svg")}) !important;
      }

      .fileUpload label.uploaded::before {
        background-image: url(${getImageUrl("delete.svg")}) !important;
      }

      .confirmation::before {
        background-image: url(${getImageUrl("confirmation-bg.svg")}) !important;
      }

      .conf-list li::after {
        background-image: url(${getImageUrl("v-line.svg")}) !important;
      }

      .conf-list li.unchecked::before {
        background-image: url(${getImageUrl("unchecked.svg")}) !important;
      }

      .conf-list li.checked::before {
        background-image: url(${getImageUrl("checked.svg")}) !important;
      }

      .tracking::before {
        background-image: url(${getImageUrl("tracking-bg.svg")}) !important;
      }

      .conf-list-inline li::after {
        background-image: url(${getImageUrl("h-line.svg")}) !important;
      }

      .conf-list-inline li.unchecked::before {
        background-image: url(${getImageUrl("unchecked.svg")}) !important;
      }

      .conf-list-inline li.checked::before {
        background-image: url(${getImageUrl("checked.svg")}) !important;
      }

      .conf-list-inline li.pending::before {
        background-image: url(${getImageUrl("pending.svg")}) !important;
      }

      .signDocuments::before {
        background-image: url(${getImageUrl("signDocuments-bg.svg")}) !important;
      }

      .reviewBg::before {
        background-image: url(${getImageUrl("review-bg.svg")}) !important;
      }

      .sidebar-menu ul.menu li.icon-alert::before {
        background-image: url(${getImageUrl("icon-alert.svg")}) !important;
      }

      .conf-list-inline li.declined:before {
        background-image:  url(${getImageUrl("declined.svg")}) !important;
    }

    .checkboxStyleThree label:before{
      background-image:  url(${getImageUrl("unchecked.svg")}) !important;
    }
    .checkboxStyleThree input[type="checkbox"]:checked+label::before
    {
      background-image:  url(${getImageUrl("checked.svg")}) !important;
    }
    .checkboxStyleThree label:after{
      background-image:  url(${getImageUrl("checked.svg")}) !important;
    }
    .modal-dialog-right-small.orange:before{
      background-image:  url(${getImageUrl("blob-orange.svg")}) !important;
    }
   .modal-dialog-right-small
   {
    position: absolute !important;
   }
    `
    return (
        <style>
            {css}
        </style>
    )
}